import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import dispatchEvent from './dispatchEvent/dispatchEvent.js'
import global from './global/global.js'
import hotkeys from './hotkeys/hotkeys.js'

export default contract({
  dispatchEvent: array([
    dispatchEvent
  ]),
  global,
  hotkeys
})
